const apis = JSON.parse(process.env.VUE_APP_FDM_API);

class Common {
    abp: any = window.abp;

    getFilingApi(tenantId, queryString = '') {
        let api = apis.api + "/filing";
        if (tenantId && apis["filingApi" + tenantId]) {
            api = apis["filingApi" + tenantId];
        }
        return api + queryString;
    }

    getTenantId() {
        var value = abp.utils.getCookieValue(abp.multiTenancy.tenantIdCookieName);
        if (!value) {
            return null;
        }

        return parseInt(value);
    }

    /**
     * @param usage 用处
     * @param compress 是否压缩
     * @param hash 生成哈希码
     * @returns 上传 API URL 地址
    */
    getUploadUrl(usage: string, compress?: boolean, hash?: boolean) {
        let queryString = `/oss/upload?usage=${usage}&hash=${hash || 'false'}&compress=${compress || 'false'}`;
        let tenantId = abp.multiTenancy.getTenantIdCookie()
        return this.getFilingApi(tenantId, queryString);
    }
}

const common = new Common();
export default common;